export enum Environment {
  DEV = 'DEV',
  PROD = 'PROD',
  TEST = 'TEST',
}
